"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBulkBusinessActiveBodyToJSON = exports.UpdateBulkBusinessActiveBodyFromJSONTyped = exports.UpdateBulkBusinessActiveBodyFromJSON = void 0;
var _1 = require("./");
function UpdateBulkBusinessActiveBodyFromJSON(json) {
    return UpdateBulkBusinessActiveBodyFromJSONTyped(json, false);
}
exports.UpdateBulkBusinessActiveBodyFromJSON = UpdateBulkBusinessActiveBodyFromJSON;
function UpdateBulkBusinessActiveBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businesses': (json['businesses'].map(_1.BusinessFromJSON)),
        'isActive': json['isActive'],
    };
}
exports.UpdateBulkBusinessActiveBodyFromJSONTyped = UpdateBulkBusinessActiveBodyFromJSONTyped;
function UpdateBulkBusinessActiveBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businesses': (value.businesses.map(_1.BusinessToJSON)),
        'isActive': value.isActive,
    };
}
exports.UpdateBulkBusinessActiveBodyToJSON = UpdateBulkBusinessActiveBodyToJSON;
